import { useEffect, useRef } from "react";

/**
 * Owns the messages-end ref and the imperative scroll-to-bottom effect.
 *
 * The trigger is intentionally an opaque value (today, isStreaming);
 * widening it later — e.g. `[isStreaming, messageCount]` — should not
 * require touching the consumer.
 */
export function useChatScroll({ trigger }) {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    const container = messagesEndRef.current?.parentNode;
    if (!container) return;
    container.scrollTop = container.scrollHeight - container.clientHeight;
  }, [trigger]);

  return { messagesEndRef };
}
